import * as Sentry from "@sentry/nextjs";
import type { CurrentUserData } from "lib/auth/currentUserHooks";

export function setCurrentUser(
  userData: Partial<Pick<CurrentUserData, "id" | "email">> | null | undefined,
): void {
  if (!userData) return;
  const { id, email } = userData;
  if (!id) return;
  Sentry.setUser({ id, username: email, email });
}

export function clearCurrentUser(): void {
  Sentry.configureScope((scope) => scope.setUser(null));
}
